import { render, staticRenderFns } from "./kiosk-re-charge.vue?vue&type=template&id=dd6c6ebc&"
import script from "./kiosk-re-charge.vue?vue&type=script&lang=js&"
export * from "./kiosk-re-charge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports